import { TailwindWrapper } from "@utils/TailwindWrapper";
import { Text } from "@ui-component-library";
import MediaSelector from "../editor/fields/MediaSelector";

const StepByStepSection = (props) => {
  return (
    <TailwindWrapper>
      <section className="w-full py-5 container">
        <div className="flex flex-col items-center gap-8 lg:gap-16 lg:flex-row py-3 lg:py-24">
          <div className="w-full flex justify-center items-center">
            <div className="w-full aspect-square bg-gray-100 rounded-xl border border-gray-200 relative overflow-hidden">
              <img
                alt={props.alt || "Hero image"}
                src={props.src || "https://placehold.co/1200x1200"}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="w-full flex flex-col justify-between">
            <Text variant="text-sm/leading-normal/medium" className="mb-5 text-[#737373]">
              {props.sectionName}
            </Text>
            <Text variant="text-2xl/leading-normal/medium" className="mb-12">
              {props.title}
            </Text>

            <div className="flex flex-col gap-8">
              {props.steps.map((step, index) => (
                <div key={index} className="flex lg:flex-row flex-col gap-5">
                  <div className="min-w-10 w-10 h-10 rounded-lg flex items-center justify-center border border-solid border-[#E6E6E6]">
                    <Text variant="text-base/leading-normal/semibold">
                      {index + 1}
                    </Text>
                  </div>

                  <div>
                    <Text variant="text-base/leading-normal/semibold" className="mb-2">
                      {step.title}
                    </Text>
                    <Text variant="text-sm/leading-normal/normal" className="text-[#737373]">
                      {step.text}
                    </Text>
                  </div>
                </div>
              ))}
            </div>
          </div>          
        </div>
      </section>
    </TailwindWrapper>
  );
};

StepByStepSection.defaultProps = {
  src: "https://placehold.co/1200x1200",
  alt: "scenic image",
  sectionName: "Step by step section",
  title: "Headline that shows solution's impact on user success.",
  steps: [
    {
      title: "Benefit driven feature title",
      text: "Shortly describe how this feature solves a specific user problem. Focus on benefits not on technical details.",
    },
    {
      title: "Benefit driven feature title",
      text: "Shortly describe how this feature solves a specific user problem. Focus on benefits not on technical details.",
    },
    {
      title: "Benefit driven feature title",
      text: "Shortly describe how this feature solves a specific user problem. Focus on benefits not on technical details.",
    },
  ],
};

StepByStepSection.fields = {
    sectionName: {
      type: "text",
      label: "Section name",
    },
    title: {
      type: "text",
      label: "Section title",
    },
    src: {
      type: "custom",
      label: "Image Source",
      render: ({ name, onChange, value }) => (
        <MediaSelector
          name={name}
          label="Image Source"
          type={"img"}
          onChange={onChange}
          value={value}
        />
      ),
    },
    alt: {
      type: "text",
      label: "Image Alt Text",
    },
    steps: {
      type: "array",
      arrayFields: {
        title: { type: "text" },
        text: { type: "textarea" },
      },
      defaultItemProps: StepByStepSection.defaultProps.steps[0],
    }
};

export default StepByStepSection;
